<template lang="pug">
  lei-modal.challenge-modal(
    v-if="showSummaryModal"
    @close="toggleModal(false)"
    title="Challenge Summary"
    size="md"
    :close-with-overlay="false")
    challenge-preview
    .container
      el-form.lei-form(ref="form" label-position="top" :model="challengeSum")
        label.challenge-label Supporting evidence
        el-form-item(label="Evidence file upload")
          el-upload.lei-upload(
            drag
            :file-list="fileList"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :auto-upload="false"
            :accept="accept"
            action="https://jsonplaceholder.typicode.com/posts/")
            i.el-icon-upload
            div.lei-upload__text Drop file here or click to upload
        //el-form-item(label="Link to Supporting Evidence Online")
          el-input.lei-input(placeholder="Type supporting text or link" v-model="challengeSum.link")
        el-form-item(
            label="Supporting text"
            prop="comment"
            :rules="commentRules"
            data-test="addition-comments-textarea"
          )
          el-input.lei-input(
            v-model="challengeSum.comment"
            type="textarea"
            placeholder="Additional comments"
            :autosize="{minRows: 4, maxRows: 7}")
        //label.challenge-label Your Contact E-Mail Address
        //el-form-item(label="Email" prop="email" :rules="emailRules")
          el-input.lei-input(placeholder="Please enter your email" v-model="challengeSum.email")
    div.challenge-modal__footer-btns(slot="footer")
      lei-btn.revise(type="default" fill @click="revise") Revise Challenge
      lei-btn(
        type="cyprus"
        fill
        :disabled="challengeIsImpossible"
        @click="save"
        data-test="submit-challenge-button"
      ) {{ submitButtonText() }}
</template>
<script>
import _ from 'lodash'
import { mapState, mapMutations, mapActions, mapGetters, } from 'vuex'
import { TOGGLE_SUMMARY_MODAL, } from '../../store/modules/record/modules/challenge/mutations-types'
import { TOGGLE_AUTH_MODAL, } from '@/store/modules/auth/mutations-types'
import { EventBus, } from '../../event-bus'
import InputCreator from '../lei-components/inputs/InputCreator'
import LeiModal from '../lei-components/LeiModal'
import LeiBtn from '../lei-components/LeiBtn'
import ChallengePreview from '@/components/challenge-components/ChallengePreview'

export default {
  components: {
    ChallengePreview,
    LeiBtn,
    LeiModal,
    InputCreator,
  },
  data () {
    return {
      disableSaveButton: false,
      evidenceFile: null,
      fileList: [],
      challengeSum: {
        // link: null,
        email: '',
        comment: '',
      },
      evidenceId: null,
      commentRules: [
        {
          required: true,
          message: 'Please input a comment',
          trigger: 'blur',
        },
      ],
      emailRules: [
        {
          type: 'email',
          message: 'Please input correct email address',
          trigger: [ 'blur', 'change', ],
        },
      ],
    }
  },
  computed: {
    description () {
      return this.challenge.text || null
    },
    type () {
      return this.challenge.type
    },
    title () {
      return `Challenge: ${this.challenge.title}`
    },
    challengeIsImpossible () {
      return this.fields.length < 1 || this.disableSaveButton
    },
    acceptableTypes () {
      return [
        'application/zip',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'text/csv',
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/tiff',
      ]
    },
    accept () {
      return this.acceptableTypes.join(',')
    },

    ...mapGetters('auth', [ 'authUser', ]),
    ...mapState('record/challenge', [ 'challenge', 'showSummaryModal', 'fields', ]),
    ...mapState('search', [ 'filters', ]),
  },
  methods: {
    submitButtonText () {
      return this.challengeIsImpossible ? 'Loading...' : 'Submit Challenge'
    },
    handleRemove () {
      this.cleanupEvidence()
    },
    async handleChange (file, fileList) {
      if (!_.hasIn(file, 'raw.type') || !this.acceptableTypes.includes(file.raw.type)) {
        this.$message({
          duration: 4000,
          type: 'error',
          message: 'The files of this type are not acceptable as an evidence.',
        })
        this.cleanupEvidence()
      } else {
        this.disableSaveButton = true
        this.fileList = fileList.slice(-1)
        this.evidenceFile = file
        const formData = new FormData()
        formData.append('file', file.raw)
        await this.postFile(formData)
          .then((data) => {
            this.evidenceId = data
            this.disableSaveButton = false
          }).catch(() => {
            this.disableSaveButton = false
          })
      }
    },
    save () {
      this.$refs.form.validate(async (valid) => {

        try {
          await this.getAuthUser()
        } catch (error) {
          this.toggleLoginModal(true)
          return
        }

        if (valid) {
          this.disableSaveButton = true
          this.saveSummary({
            comment: this.challengeSum.comment,
            evidenceId: this.evidenceId,
            // evidenceText: this.challengeSum.link,
            // email: this.challengeSum.email,
          }).then(() => {
            this.cleanup()
            this.$message({
              type: 'success',
              message: 'Challenge was successfully submitted. Check your email for detailed information.',
            })
            this.disableSaveButton = false
            EventBus.$emit('summary-save')
            this.toggleModal(false)
          }).catch(() => {
            this.disableSaveButton = false
          })
        }
      })
    },
    revise () {
      this.toggleModal(false)
    },
    setInputValue ({ value, }) {
      this.value = value
    },
    setEnumValue ({ value, }) {
      this.value = value
    },
    cleanup () {
      this.cleanupEvidence()
      this.challengeSum = {
        email: '',
        comment: '',
      }
    },
    cleanupEvidence () {
      this.evidenceFile = null
      this.evidenceId = null
      this.fileList = []
    },

    ...mapMutations('record/challenge', {
      toggleModal: TOGGLE_SUMMARY_MODAL,
    }),
    ...mapActions('record/challenge', [ 'postFile', 'saveSummary', ]),
    ...mapActions('auth', [ 'getAuthUser', ]),
    ...mapMutations('auth', {
      toggleLoginModal: TOGGLE_AUTH_MODAL,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-modal
    &__footer-btns
      width 100%
      display flex
      flex-direction: column

    &.modal
      z-index 102

    .challenge-label
      line-height 50px
      margin-bottom 10px
      font-size 1.1rem
      font-weight 600
      text-transform uppercase

    .description
      text-align justify
      color $default-color
      line-height 1.25

  @media (min-width: $laptop)
    .challenge-modal
      &__footer-btns
        flex-direction: row

      .container
        margin-bottom 15px

        &:last-child
          margin-bottom 0

      .revise
        margin-right 10px

</style>



// WEBPACK FOOTER //
// src/components/modals/ChallengeSummaryModal.vue